import {useNavigation} from '@react-navigation/core';
import React from 'react';
import {View} from 'react-native';
import {images} from '../../../../../../../assets/icons';
import {Link} from '../../../../../../../shared/components/link';
import {Text} from '../../../../../../../shared/components/text';
import {dateFormats} from '../../../../../../../shared/constants/date';
import {RequestResponsePayload} from '../../../../../../../shared/models/api';
import {datePipe} from '../../../../../../../shared/pipes';
import {Screens} from '../../../../../../../shared/routing';
import {Styles} from '../styles';
export interface TopicTableColumnProps {
  request: RequestResponsePayload;
  styles?: Styles;
}

export const RequestIdColumn = ({request, styles}: TopicTableColumnProps) => {
  const isRead = request.isRead;
  return (
    <Text style={isRead ? styles?.colBodyText : styles?.colBodyTextNotRead} numberOfLines={1}>
      {request.id}
    </Text>
  );
};

export const IconColumn = ({request, styles}: TopicTableColumnProps) => {
  const Icon = request.isRead ? images.NotCheckRound : images.CheckRound;
  return (
    <View style={[styles?.icon, styles?.iconContainer]}>
      <Icon height={styles?.icon.height} width={styles?.icon.width} color={styles?.icon.color} />
    </View>
  );
};

export const TopicColumn = ({request}: TopicTableColumnProps) => {
  const {isRead} = request;
  const nav = useNavigation();
  return (
    <Link
      testID={`topic-column-${request.id}-link-id`}
      navigate={nav.navigate}
      screenParams={{id: request.id || ''}}
      screen={Screens.SupportServiceTopics}>
      <Text type={isRead ? 'h5Light' : 'h5'} numberOfLines={3} ellipsizeMode='tail'>
        {request.topic}
      </Text>
    </Link>
  );
};

export const DateOfApplicationColumn = ({request, styles}: TopicTableColumnProps) => {
  const isRead = request.isRead;
  return (
    <Text style={isRead ? styles?.colBodyText : styles?.colBodyTextNotRead} numberOfLines={1}>
      {datePipe(request.dateTime)}
    </Text>
  );
};

export const TimeColumn = ({request, styles}: TopicTableColumnProps) => {
  const isRead = request.isRead;
  return (
    <Text style={isRead ? styles?.colBodyText : styles?.colBodyTextNotRead} numberOfLines={1}>
      {datePipe(request.dateTime, dateFormats.time)}
    </Text>
  );
};
